const FormRedirection = new function () {
  this.init = function (node) {
    // CF7 on sent
    document.addEventListener('wpcf7mailsent', function (event) {
      const successUrl = event.detail.inputs.filter(el => el.name == 'successUrl')

      if (successUrl[0]) {
        location = successUrl[0].value
      }

    }, false);

  }
};
export default FormRedirection;


global.FormRedirection = FormRedirection;
